(() => {
  "use strict";
  function t(t) {
    return (
      (function (t) {
        if (Array.isArray(t)) return e(t);
      })(t) ||
      (function (t) {
        if (
          ("undefined" != typeof Symbol && null != t[Symbol.iterator]) ||
          null != t["@@iterator"]
        )
          return Array.from(t);
      })(t) ||
      (function (t, n) {
        if (!t) return;
        if ("string" == typeof t) return e(t, n);
        var i = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === i && t.constructor && (i = t.constructor.name);
        if ("Map" === i || "Set" === i) return Array.from(t);
        if (
          "Arguments" === i ||
          /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)
        )
          return e(t, n);
      })(t) ||
      (function () {
        throw new TypeError(
          "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
        );
      })()
    );
  }
  function e(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var n = 0, i = new Array(e); n < e; n++) i[n] = t[n];
    return i;
  }
  var n = function (e) {
    var n = e.product,
      i = e.variant;
    return {
      swatchClicked: false,
      selectedSwatch: i,
      variants: null,
      selectedVariant: null,
      currentProduct: null,
      productDetailsDrawerIsOpen: !1,
      showDrawer: !1,
      selectedOptionId: null,
      selectedVariantDimensions: null,
      productVariantsDimensions: null,
      optionRadios: null,
      optionAllRadios: null,
      slider: null,
      selectedIndex: 0,
      selectedVariantImageID: 0,
      drawerInnerContainer: null,
      isMobile: !1,
      unavailableVariants: null,
      unavailableOptionsValues: [],
      unavailableVariantsTitles: [],
      selectedOptionPosition: 0,
      init: function () {
        var t = this;
        (this.currentProduct = n),
          (this.variants = n.variants),
          (this.selectedVariant = i),
          (this.selectedSwatch = i),
          (this.selectedVariantImageID =
            this.selectedVariant.featured_media.id),
          window.addEventListener("resize", function () {
            t.isMobile = window.innerWidth > 990;
          });
      },
      removeEventListeners: function () {},
      selectColor: function (t) {
        this.swatchClicked = true;
        var e = t.variant;
        this.selectedSwatch = e;
      },
      setSelectedVariant: function (t, e) {
        var n = this;
        (this.selectedVariant = this.variants.filter(function (t) {
          return (
            t.title.trim().toLowerCase() ===
            n.optionAllRadios
              .filter(function (t) {
                return t.checked;
              })
              .map(function (t) {
                return t.value;
              })
              .join(" / ")
              .trim()
              .toLowerCase()
          );
        })[0]),
          this.$nextTick(function () {
            (n.variants = n.currentProduct.variants),
              n.selectedVariant &&
                (n.getSelectedVariantDimensions(),
                n.selectedVariant.featured_media &&
                  ((n.selectedVariantImageID =
                    n.selectedVariant.featured_media.id),
                  n.slideToSelectedVariantImage(n.selectedVariantImageID))),
              n.currentProduct.options.length > 1 && n.setAvailableVariants(t);
          });
      },
      setAvailableVariants: function (e) {
        var n = this;
        (this.selectedOptionPosition =
          this.selectedVariant.options.indexOf(e.target.value) + 1),
          (this.unavailableOptionsValues = []),
          (this.unavailableVariantsTitles = []);
        var i = t(document.querySelectorAll(".options-list")).filter(function (
          t
        ) {
          return (
            +t.getAttribute("data-option-position") !== n.selectedOptionPosition
          );
        });
        (this.unavailableVariants = this.variants
          .filter(function (t) {
            return t.options.includes(e.target.value);
          })
          .filter(function (t) {
            return !t.available;
          })),
          i.forEach(function (t, e) {
            n.optionRadios = t.querySelectorAll("[data-product-variants]");
          }),
          this.optionRadios.forEach(function (t) {
            t.disabled = !1;
          }),
          this.unavailableVariants.length > 0 &&
            this.unavailableVariants.forEach(function (t) {
              n.unavailableVariantsTitles.includes(t.title) ||
                n.unavailableVariantsTitles.push(t.title),
                t.options.forEach(function (t) {
                  n.unavailableOptionsValues.includes(t) ||
                    n.unavailableOptionsValues.push(t);
                });
            }),
          this.unavailableOptionsValues.length > 0 &&
            this.unavailableOptionsValues.forEach(function (t) {
              n.optionRadios.forEach(function (n) {
                n.value === t && t !== e.target.value && (n.disabled = !0);
              });
            });
      },
      slideToSelectedVariantImage: function (t) {
        (this.selectedIndex = this.drawerInnerContainer
          .querySelector('[data-image-id="'.concat(t, '"]'))
          .getAttribute("data-slide-index")),
          this.slider.slideTo(this.selectedIndex, 100, null);
      },
      openProductDetailsDrawer: function (e) {
        var n = this;
        e.variant;
        this.$nextTick(function () {
          (n.optionAllRadios = t(
            document.querySelectorAll("[data-product-variants]")
          )),
            (n.drawerInnerContainer = document.querySelector(
              ".product-details-drawer__inner"
            )),
            n.getSelectedVariantDimensions(),
            n.slideToSelectedVariantImage(n.selectedVariantImageID),
            document
              .querySelector(".product-card-drawer .button--close")
              .focus();
        }),
          (this.productDetailsDrawerIsOpen = !0),
          setTimeout(function () {
            (n.showDrawer = !0), document.body.classList.add("overflow-hidden");
          }, 200);
      },
      closeProductDetailsDrawer: function () {
        var t = this;
        document.body.classList.remove("overflow-hidden"),
          (this.showDrawer = !1),
          setTimeout(function () {
            t.productDetailsDrawerIsOpen = !1;
          }, 300);
      },
      incrementQty: function (t) {
        Alpine.store("cart").qty++;
      },
      decrementQty: function (t) {
        Alpine.store("cart").qty > 1 && Alpine.store("cart").qty--;
      },
      getSelectedVariantDimensions: function () {
        var e = this;
        this.$nextTick(function () {
          var n = document.querySelector(
            "[data-variants-dimensions-".concat(e.currentProduct.id, "]")
          ).innerHTML;
          (e.productVariantsDimensions = JSON.parse(n)),
            e.productVariantsDimensions &&
              (e.selectedVariantDimensions = t(
                e.productVariantsDimensions.variant_dimensions
              ).find(function (t) {
                return t[e.selectedVariant.id];
              })[e.selectedVariant.id]);
        });
      },
    };
  };
  window.addEventListener("alpine:init", function () {
    Alpine.data("productCard", n);
  });
})();
